import React, { useEffect, useRef, useState } from 'react';
import { Grid, TextField } from '@mui/material';
import { StyledSectionHeader } from '../styles';

import { formatPhoneNumberToNANPFormat } from '../../../utils/helpers';
import { COLORS } from '../../../utils/colors';
import { IPlan } from '../../../global/interfaces';

const HOMEOWNER_CONTACT_INFORMATION = [
  {
    label: 'First Name *',
    name: 'firstname',
  },
  {
    label: 'Last Name *',
    name: 'lastname',
  },
  {
    label: 'Email *',
    name: 'email',
  },
  {
    label: 'Mobile Number *',
    name: 'mobile',
  },
];

interface IFieldRefs {
  [key: string]: React.RefObject<HTMLInputElement>;
}

interface IProps {
  values: any;
  errors: any;
  setFieldValue: any;
  submitted: boolean;
  setSubmitted: any;
}

const HomeOwnerContact = ({
  values,
  errors,
  setFieldValue,
  submitted,
  setSubmitted,
}: IProps) => {
  const fieldRefs = useRef<IFieldRefs>({});
  const [previousValue, setPreviousValue] = useState<string>('');

  const handleDeletion = (
    previousValue: string,
    newValue: string,
    cursorPosition: number,
  ): string => {
    let digitsOnly = newValue.replace(/\D/g, '');
    const isDeletingFormatChar =
      previousValue.length - newValue.length !== 1 ||
      (previousValue[cursorPosition] &&
        previousValue[cursorPosition].match(/\D/));

    if (isDeletingFormatChar) {
      let indexToDeleteFrom =
        previousValue.substring(0, cursorPosition).replace(/\D/g, '').length -
        1;
      digitsOnly = digitsOnly.substring(0, indexToDeleteFrom);
    }

    newValue = formatPhoneNumberToNANPFormat(digitsOnly);

    return newValue;
  };

  const handleMobileNumberChange = (name: string) => (e?: any) => {
    let newValue: string = e.target.value;
    const isDeletion = newValue.length < previousValue.length;
    const cursorPosition = e.target.selectionStart;

    if (isDeletion) {
      newValue = handleDeletion(previousValue, newValue, cursorPosition);
    } else {
      newValue = formatPhoneNumberToNANPFormat(newValue);
    }
    setFieldValue(name, newValue);
    setPreviousValue(newValue);
    setSubmitted(false);
  };

  const handleInput = (name: string) => (e?: any) => {
    setFieldValue(name, e.target.value);
    setSubmitted(false);
  };

  return (
    <Grid item xs={12} justifyContent="flex-end">
      <Grid item xs={12} mb={4} sx={{ ml: '-2rem' }}>
        <StyledSectionHeader>PROPERTY OWNER CONTACT</StyledSectionHeader>
      </Grid>

      <Grid container spacing={4}>
        {HOMEOWNER_CONTACT_INFORMATION.map(({ label, name }) => {
          return (
            <Grid item xs={12} md={6} key={name}>
              <TextField
                fullWidth
                onFocus={() => {}}
                label={label}
                variant="outlined"
                value={values[name]}
                onChange={
                  name === 'mobile'
                    ? handleMobileNumberChange(name)
                    : handleInput(name)
                }
                sx={{
                  '& > p': {
                    zIndex: 99,
                  },
                }}
                error={submitted && !!errors[name]}
                helperText={
                  submitted &&
                  (errors[name] ? (
                    <span style={{ color: COLORS.RED }}>{errors[name]}</span>
                  ) : (
                    name === 'mobile' &&
                    `This needs be to the device number that you will attend your Virtual HomeCare consultation on.`
                  ))
                }
                inputRef={fieldRefs.current[name]}
              />
            </Grid>
          );
        })}
      </Grid>
    </Grid>
  );
};

export default HomeOwnerContact;
